<template>
    <div id="counsel">
        <div class="form-inner">
            <div class="form">
                <p>※무료 체험 신청을 하시면 담당자가 빠른 시간내 연락드립니다.</p>
<!--                <div>-->
<!--                    <input type="radio" id="a1" name="aa" value="A" v-model="radioVal">-->
<!--                    <label for="a1">교사</label>-->
<!--                    <input type="radio" id="a2" name="aa" value="B" v-model="radioVal">-->
<!--                    <label for="a2">방과후 선생님</label>-->
<!--                    <input type="radio" id="a3" name="aa" value="C" v-model="radioVal">-->
<!--                    <label for="a3">기타</label>-->
<!--                </div>-->
                <em>필수 입력 사항</em>
                <table>
<!--                    <tr v-show="radioVal !== 'B'">-->
<!--                        <th><span>{{ radioVal === 'A' ? '신청기관명' : '소속' }}</span></th>-->
<!--                        <td>-->
<!--                            <input type="text" v-model="schoolName" :placeholder="radioVal === 'A' ? '예) 아이런초등학교' : '예) 단비학원'" @click="sendGtag('schoolName')" />-->
<!--                        </td>-->
<!--                    </tr>-->
                    <tr>
                        <th><span>신청기관명</span></th>
                        <td class="pt-6">
                            <input type="text" v-model="schoolName" placeholder="신청기관명을 입력해주세요." @click="sendGtag('schoolName')" />
                        </td>
                    </tr>
                    <tr>
                        <th><span>신청인</span></th>
                        <td>
                            <input type="text" v-model="userName" placeholder="신청하시는 분의 성함을 입력해주세요." @click="sendGtag('userName')" />
                        </td>
                    </tr>
                    <tr>
                        <th><span>연락처</span></th>
                        <td>
                            <input type="tel" v-model="phoneNumber" placeholder="휴대폰 번호를 입력해주세요." @click="sendGtag('phoneNumber')" />
                        </td>
                    </tr>
                    <tr>
                        <th><span>이메일</span></th>
                        <td>
                            <input type="email" v-model="email" placeholder="이메일 주소를 입력해주세요." @click="sendGtag('email')" />
                        </td>
                    </tr>
<!--                    <tr v-show="radioVal !== 'B'">-->
<!--                        <th>교육 인원</th>-->
<!--                        <td>-->
<!--                            <input type="text" v-model="trainingPersonnel" placeholder="예) 100명" @click="sendGtag('trainingPersonnel')" />-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr v-show="radioVal !== 'B'">-->
<!--                        <th>교육 시간</th>-->
<!--                        <td>-->
<!--                            <input type="text" v-model="trainingTime" placeholder="예) 6시간" @click="sendGtag('trainingTime')" />-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr v-show="radioVal !== 'B'">-->
<!--                        <th>예산 규모</th>-->
<!--                        <td>-->
<!--                            <input type="text" v-model="budget" placeholder="예) 150만원" @click="sendGtag('budget')" />-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr v-show="radioVal === 'B'">-->
<!--                        <th>활동 지역</th>-->
<!--                        <td>-->
<!--                            <input type="text" v-model="activityArea" placeholder="예) 서울" @click="sendGtag('activityArea')" />-->
<!--                        </td>-->
<!--                    </tr>-->
                </table>
                <dl>
                    <dt>에이아이런을 알게된 경로</dt>
                    <dd>
                        <input type="radio" id="a" value="동료 교사 추천" v-model="fromVal">
                        <label for="a">동료 교사 추천</label>
                        <input type="radio" id="b" value="직접 검색(네이버/다음)" v-model="fromVal">
                        <label for="b">인터넷 검색</label>
<!--                        <input type="radio" id="c" value="직접 검색(구글)" v-model="fromVal">-->
<!--                        <label for="c">직접 검색(구글)</label>-->
<!--                        <input type="radio" id="d" value="SNS 광고" v-model="fromVal">-->
<!--                        <label for="d">SNS 광고</label>-->
<!--                        <input type="radio" id="e" value="홍보 브로셔" v-model="fromVal">-->
<!--                        <label for="e">홍보 브로셔</label>-->
                        <div>
                            <input type="radio" id="f" value="기타" v-model="fromVal">
                            <label for="f" class="mr-2">기타</label>
                            <span style="margin: 4px;">(<input type="text" v-model="fromValEtcVal">)</span>
<!--                            <span v-show="fromValEtcFlag">(<input type="text" v-model="fromValEtcVal">)</span>-->
                        </div>
                    </dd>
                    <dd>
                        <input type="checkbox" id="g" v-model="letterYn">
                        <label for="g">인공지능 교육흐름 뉴스레터 구독신청</label>
                    </dd>
                </dl>
                <div class="btn-wrap">
                    <span :class="{'disabled' : btnDisabled}">
                        <a @click="submit()"><img src="../img/btn-apply_icon.svg" width="30" height="auto" /> 신청하기</a>
                    </span>
                </div>
<!--                <small>입력하신 정보는 서비스 이용 상담, 관련 자료 및 공지사항을 보내는 용도 외에는 이용되지 않습니다.</small>-->
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "counsel",
        data() {
            return {
                schoolName: '',
                userName: '',
                phoneNumber: '',
                email: '',
                trainingPersonnel: '', // 교육 인원
                trainingTime: '', // 교육 시간
                budget: '', // 예산
                fromVal: '동료 교사 추천', // 알게된 경로
                fromValEtcFlag: false, // 알게된 경로가 '직접 입력' 이면 true
                fromValEtcVal: '', // 직접입력일때 값
                btnDisabled: false,

                radioVal: 'A',
                activityArea: '',
                letterYn: true,
            };
        },
        created: function() {
        },
        methods: {
            submit(){
                gtag('event', '(하단) 상담 신청하기', {
                    'event_category': 'click',
                    'event_label': '(하단) 상담 신청하기',
                    'value': '',
                });

                if(!this.btnDisabled) {
                    this.btnDisabled = true;
                } else {
                    return false;
                }

                // console.log(this.radioVal);

                if(this.radioVal !== 'B' && this.schoolName === '') {
                    if(this.radioVal === 'A') {
                        swal("필수 항목 미입력", "'신청기관명'을 입력해주세요.", "error" );
                    } else {
                        swal("필수 항목 미입력", "'소속'을 입력해주세요.", "error" );
                    }
                    this.btnDisabled = false;
                    return false;
                }
                if(this.userName === '') {
                    swal("필수 항목 미입력", "'신청인'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                } else {
                    // let userNamePattern = /^[ㄱ-ㅎㅏ-ㅣ가-힣]{2,20}$/;
                    // if(!userNamePattern.test(this.userName)) {
                    //     alert('최소 2글자 이상의 한글 이름을 입력해주시기 바랍니다.');
                    //     this.btnDisabled = false;
                    //     return false;
                    // }
                }
                if(this.phoneNumber === '') {
                    swal("필수 항목 미입력", "'연락처'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                }
                if(this.email === '') {
                    swal("필수 항목 미입력", "'이메일'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                } else {
                    var emailPattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
                    if(!emailPattern.test(this.email)){
                        swal("이메일 형식 오류", "올바른 이메일 형식이 아닙니다.", "error" );
                        this.btnDisabled = false;
                        return false;
                    }
                }

                let parameters = {
                    schoolName: this.schoolName,
                    userName: this.userName,
                    phoneNumber: this.phoneNumber,
                    email: this.email,
                    trainingPersonnel: this.trainingPersonnel,
                    trainingTime: this.trainingTime,
                    budget: this.budget,
                    fromVal: this.fromVal,
                    radioVal: this.getRadioRealValue(),
                    activityArea: this.activityArea,
                    letterYn: this.letterYn ? 'Y' : 'N',
                };

                if(this.fromValEtcFlag) {
                    if(this.fromValEtcVal) {
                        parameters.fromVal = '기타:' + this.fromValEtcVal;
                    }
                }
                // console.log(parameters);

                let url = 'https:\/\/danbee.ai/chatflow/event/v2.0/10b92062-314a-4886-b64b-980fb0a3c228/b676564c-04d8-46ac-8238-23910d46ab76/message.do'; // 운영 > (주)단비아이엔씨 > [삭제X] 아이런 랜딩 무료체험 접수
                if(location.hostname.indexOf('localhost') > -1 || location.hostname.indexOf('dev.') > -1) {
                    url = 'https:\/\/dev.danbee.ai/chatflow/event/v2.0/6f1c974b-e85d-403e-8db0-f0f004af47c1/b676564c-04d8-46ac-8238-23910d46ab76/message.do'; // 개발 > PA > [삭제X] 아이런 랜딩 무료체험 접수
                }

                axios({
                    method : 'POST',
                    url : url,
                    headers : {
                        'Content-Type' : 'application/json'
                    },
                    data : JSON.stringify({
                        chatbot_id: '10b92062-314a-4886-b64b-980fb0a3c228',
                        parameters: parameters,
                    })
                }).then((response) => {
                    // console.log('response : ');
                    // console.log(response);
                    swal("접수 완료", "상담신청이 접수되었습니다.", "success" );
                    // alert('상담신청이 접수되었습니다.');
                    this.resetParameters();

                    gtag('event', 'goal', {
                        'event_category': 'click',
                        'event_label': 'goal',
                        'value': '',
                    });
                }).catch((error) => {
                    swal("접수 실패", "오류가 발생했습니다. 관리자에게 문의바랍니다.", "error" );
                    this.btnDisabled = false;
                });
            },
            resetParameters() {
                this.btnDisabled = false;
                this.schoolName = '';
                this.userName = '';
                this.phoneNumber = '';
                this.email = '';
                this.trainingPersonnel = '';
                this.trainingTime = '';
                this.budget = '';
                this.fromVal = '동료 교사 추천';
                this.fromValEtcVal = '';
                this.fromValEtcFlag = false;
                this.activityArea = '';
            },

            getRadioRealValue() {
                switch (this.radioVal) {
                    case 'A':
                        return '교사';
                    case 'B':
                        return '방과후 선생님';
                    case 'C':
                        return '기타';
                    default:
                        return '';
                }
            },
            sendGtag(type) {
                let event_label = '';
                // console.log(type);
                switch (type) {
                    case 'schoolName':
                        event_label = '(무료체험신청) 소속';
                        break;
                    case 'userName':
                        event_label = '(무료체험신청) 신청인';
                        break;
                    case 'phoneNumber':
                        event_label = '(무료체험신청) 연락처';
                        break;
                    case 'email':
                        event_label = '(무료체험신청) 이메일';
                        break;
                    case 'trainingPersonnel':
                        event_label = '(무료체험신청) 교육 인원';
                        break;
                    case 'trainingTime':
                        event_label = '(무료체험신청) 교육 시간';
                        break;
                    case 'budget':
                        event_label = '(무료체험신청) 예산 규모';
                        break;
                    case 'activityArea':
                        event_label = '(무료체험신청) 활동 지역';
                        break;
                }
                gtag('event', event_label, {
                    'event_category': 'click',
                    'event_label': event_label,
                    'value': '',
                });
            }
        },
        beforeDestroy() {
        },
        destroyed () {
        },
        watch: {
            fromVal: function (val, oldVal) {
                if (val === '기타') {
                    this.fromValEtcFlag = true;
                } else {
                    this.fromValEtcFlag = false;
                }

                if(val !== oldVal) {
                    gtag('event', '(무료체험신청) 알게된 경로', {
                        'event_category': 'click',
                        'event_label': '(무료체험신청) 알게된 경로',
                        'value': val,
                    });
                }
            },
        },
        computed: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/counsel.vue